import requester from '@/lib/axios';
import { HackathonStage } from '@/models/Hackathon';
import { BaseFilters, ListServiceFunc } from '@/models/Service';

export type HackathonStagesFilters = BaseFilters & {
  edition?: number;
  date?: string;
  hackathon?: number;
};

export const listHackathonStages: ListServiceFunc<
  HackathonStage,
  HackathonStagesFilters
> = async params => {
  const { data } = await requester().get(`hackathon-stages/`, {
    params,
  });
  return data;
};

export const createHackathonStage = async (
  hackathonStage: Omit<HackathonStage, 'id'>,
) => {
  const { data } = await requester().post<HackathonStage>(
    'hackathon-stages/',
    hackathonStage,
  );
  return data;
};

export const updateHackathonStage = async (
  hackathonStageId: number,
  hackathonStage: Partial<HackathonStage>,
) => {
  const { data } = await requester().patch<HackathonStage>(
    `hackathon-stages/${hackathonStageId}/`,
    hackathonStage,
  );
  return data;
};

export const deleteHackathonStage = async (hackathonStageId: number) => {
  const { data } = await requester().delete<HackathonStage>(
    `hackathon-stages/${hackathonStageId}/`,
  );
  return data;
};
